
    <p-button
    [ngClass]="classes"
    [label]="text"
    [icon]="iconClass"
    [styleClass]="styleClass"
    [iconPos]="iconPos"
    [disabled]="disabled"
    (onClick)="onClick.emit($event)"></p-button>
  